import { render, staticRenderFns } from "./block-templates-gallery-view.vue?vue&type=template&id=f713204e&scoped=true&lang=pug"
import script from "./block-templates-gallery-view.vue?vue&type=script&lang=js"
export * from "./block-templates-gallery-view.vue?vue&type=script&lang=js"
import style0 from "./block-templates-gallery-view.vue?vue&type=style&index=0&id=f713204e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f713204e",
  null
  
)

export default component.exports